import Route from '@ember/routing/route';
import { service } from '@ember/service';
import metricValidations from 'scaleflow/validators/metric';
import targetValidations from 'scaleflow/validators/target';
import { Changeset } from 'ember-changeset';
import { get } from '@ember/object';
import { instrumentRoutePerformance } from '@sentry/ember';

class BusinessMetricsCreateRoute extends Route {
  @service store;

  metricValidator({ key, newValue }) {
    let validator = get(metricValidations, key);
    if (typeof validator === 'function') {
      return validator(key, newValue);
    }
  }

  targetValidator({ key, newValue }) {
    let validator = get(targetValidations, key);
    if (typeof validator === 'function') {
      return validator(key, newValue);
    }
  }

  beforeModel() {
    return this.store.findAll('goal');
  }

  model() {
    return this.store.createRecord('metric');
  }

  setupController(controller, model) {
    super.setupController(controller, model);
    const metricChangeset = Changeset(
      model.changeset_object,
      this.metricValidator,
    );
    const targetChangeset = Changeset(model, this.targetValidator);

    controller.set('metricChangeset', metricChangeset);
    controller.set('targetChangeset', targetChangeset);
  }

  resetForm(controller) {
    controller.set('activeStep', 0);
    controller.set('selectedGoals', []);
    controller.set('goalSearch', '');
  }

  resetController(controller, isExiting, transition) {
    if (isExiting && transition.targetName !== 'error') {
      this.resetForm(controller);
    }
  }
}

export default instrumentRoutePerformance(BusinessMetricsCreateRoute);
